import type { AppPageKey } from "../router/AppRouter";

interface LeftMenuProps {
  activePage: AppPageKey;
  onNavigate: (page: AppPageKey) => void;
}

const menuItems: Array<{ key: AppPageKey; label: string }> = [
  { key: "dashboard", label: "Showcase" },
  { key: "arch-designer", label: "Restoration Designer" },
  { key: "architecture", label: "Architecture" },
];

export function LeftMenu({ activePage, onNavigate }: LeftMenuProps) {
  return (
    <aside className="left-menu">
      <div className="left-menu__section-title">Navigation</div>

      <nav className="left-menu__nav">
        {menuItems.map((item) => {
          const isActive = activePage === item.key;

          return (
            <button
              key={item.key}
              className={`left-menu__item ${isActive ? "left-menu__item--active" : ""}`}
              onClick={() => onNavigate(item.key)}
            >
              {item.label}
            </button>
          );
        })}
      </nav>
    </aside>
  );
}